import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { siteInfo } from '@/mocks/comics';

export default function AboutPage() {
  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: siteInfo.name,
    url: siteInfo.url,
    description: siteInfo.description,
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: siteInfo.phone,
      contactType: 'customer service',
      email: siteInfo.email,
    },
    address: {
      '@type': 'PostalAddress',
      streetAddress: siteInfo.address,
    },
  };

  return (
    <div className="min-h-screen bg-background-50">
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <Navbar />

      <div className="pt-16">
        <Breadcrumb items={[{ label: '首页', href: '/' }, { label: '关于我们' }]} />
      </div>

      <main>
        <section className="relative w-full h-[280px] md:h-[360px] flex items-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Korean%20webtoon%20manhwa%20warm%20cozy%20library%20reading%20atmosphere%2C%20soft%20coral%20and%20golden%20ambient%20lighting%2C%20dreamy%20artistic%20illustration%2C%20warm%20tones%2C%20elegant%20minimalist%20design%2C%20inviting%20mood&width=1800&height=500&seq=manhwa-about-hero&orientation=landscape"
            alt="关于韩漫屋"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>
          <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
            <h1 className="text-3xl md:text-5xl font-heading text-background-50 mb-3 tracking-wide">关于我们</h1>
            <p className="text-background-50/75 text-sm md:text-base max-w-lg">了解韩漫屋的品牌故事与使命</p>
          </div>
        </section>

        <section className="py-16 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
            <div className="flex flex-col lg:flex-row gap-12">
              <div className="lg:w-3/5">
                <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-5">品牌故事</h2>
                <p className="text-foreground-700 text-sm leading-relaxed mb-4">
                  韩漫屋成立于2022年，是国内领先的免费韩漫在线阅读平台。我们热爱韩国漫画，致力于为广大漫迷提供一个免费、高清、无删减的阅读空间。
                </p>
                <p className="text-foreground-700 text-sm leading-relaxed mb-4">
                  我们的团队由一群热爱二次元文化的年轻人组成，深知漫迷们对优质阅读体验的渴望。从最初的小众分享站到今天汇集超过5000部韩漫资源的大型平台，我们始终坚持"免费、完整、优质"的初心。
                </p>
                <p className="text-foreground-700 text-sm leading-relaxed">
                  未来，我们将继续拓展漫画资源，优化阅读体验，让更多漫迷能够轻松享受韩国漫画的魅力。
                </p>
              </div>

              <div className="lg:w-2/5">
                <div className="relative rounded-2xl overflow-hidden bg-secondary-100/50 p-8 min-h-[200px]">
                  <div className="absolute top-0 right-0 w-40 h-40 bg-secondary-200/60 rounded-full -translate-y-1/2 translate-x-1/4"></div>
                  <div className="absolute bottom-0 left-0 w-32 h-32 bg-primary-100/40 rounded-full translate-y-1/3 -translate-x-1/3"></div>
                  <div className="relative z-10 grid grid-cols-3 gap-6 mt-4">
                    <div className="text-center">
                      <p className="text-3xl font-heading text-primary-500">5000+</p>
                      <p className="text-foreground-500 text-xs mt-1">漫画资源</p>
                    </div>
                    <div className="text-center">
                      <p className="text-3xl font-heading text-primary-500">100万+</p>
                      <p className="text-foreground-500 text-xs mt-1">日活读者</p>
                    </div>
                    <div className="text-center">
                      <p className="text-3xl font-heading text-primary-500">50+</p>
                      <p className="text-foreground-500 text-xs mt-1">合作方</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-16 md:py-20 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-10 text-center">用户口碑</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {[
                { name: '小糖果', role: '资深漫迷', text: '这个网站简直是我的快乐源泉！漫画资源超级全，更新速度也很快，每天都在等更新。下拉式阅读体验太棒了！' },
                { name: '追漫少年', role: '活跃读者', text: '从其他平台过来的，这里的分类做得特别细致，找漫画超方便。推荐功能也很精准，帮我发现了不少宝藏作品！' },
                { name: '漫画控', role: '忠实用户', text: '最喜欢这里的画质了，高清无删减，每一话都看得很过瘾。评论区氛围也超好，大家都很友好地讨论剧情。' },
              ].map((item, i) => (
                <div key={i} className="bg-background-50 border border-background-200/70 rounded-xl p-6">
                  <i className="ri-double-quotes-l text-3xl text-primary-300 mb-3 block"></i>
                  <p className="text-foreground-700 text-sm leading-relaxed mb-4">{item.text}</p>
                  <p className="text-foreground-900 font-medium text-sm">{item.name}</p>
                  <p className="text-foreground-400 text-xs">{item.role}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-16 md:py-20 bg-background-50">
          <div className="max-w-4xl mx-auto px-4 md:px-8 lg:px-12">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-10 text-center">联系我们</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
              <div className="text-center p-6 bg-background-100 rounded-xl">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-primary-100 flex items-center justify-center">
                  <i className="ri-mail-line text-primary-500 text-xl"></i>
                </div>
                <h3 className="font-medium text-foreground-900 text-sm mb-1">邮箱</h3>
                <p className="text-foreground-500 text-xs">{siteInfo.email}</p>
              </div>
              <div className="text-center p-6 bg-background-100 rounded-xl">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-phone-line text-accent-600 text-xl"></i>
                </div>
                <h3 className="font-medium text-foreground-900 text-sm mb-1">电话</h3>
                <p className="text-foreground-500 text-xs">{siteInfo.phone}</p>
              </div>
              <div className="text-center p-6 bg-background-100 rounded-xl">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-secondary-100 flex items-center justify-center">
                  <i className="ri-map-pin-line text-secondary-600 text-xl"></i>
                </div>
                <h3 className="font-medium text-foreground-900 text-sm mb-1">地址</h3>
                <p className="text-foreground-500 text-xs">{siteInfo.address}</p>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}